export default __webpack_public_path__ + "static/media/chair.f10c11b9.jpg";